import { Inject } from '@odinjs/odin';

import { Value } from '@philips-emr/tws-core';
import { HistoryService } from '@philips-emr/tws-core/lib/services/history-service';

interface DataContext {
  get(key: string): Value;
  getBulkData(): Record<string, Value>;
  set(data: { [key: string]: Value }): void;
  readOnly(): {};
}

export default class BaseController {

  @Inject('HistoryService')
  protected historyService: HistoryService;
  @Inject('Context')
  protected context: DataContext;

}
